export default {
  labels: {
    reply: 'Ejerens svar',
  },
  form: {
    reply_text: {
      placeholder: 'Skriv dit svar...',
    },
  },
  buttons: {
    generate_reply: 'Generer svar',
    submit_reply: 'Send svar',
  },
  toasts: {
    failed_to_create_reply: 'Svaret kunne ikke oprettes',
    failed_to_generate_ai_reply: 'AI-svaret kunne ikke genereres',
  },
};
